import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { VueCookieNext } from 'vue-cookie-next'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

// axios.defaults.baseURL = 'http://nashoof-sd.com/BYTE_AREA/NashoofAPI/APIs/'
createApp(App)
     .use(router)
     .use(VueCookieNext)
     .use(Toast)
     .use(VueLoading, {
          // props
          color: '#236EC5',
          loader:'dots'
      })
     .mount('#app')
